import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function RootRedirect() {
  const { isAuthenticated, role, authReady } = useAuth();

  if (!authReady) return null;

  if (!isAuthenticated) {
    return <Navigate to="/seller/login" replace />;
  }

  if (role === "manager") {
    return <Navigate to="/manager/dashboard" replace />;
  }

  if (role === "seller") {
    return <Navigate to="/seller/dashboard" replace />;
  }

  return <Navigate to="/seller/login" replace />;
}
